import React from 'react';
import { register } from '../../i18n';
import '../../css/PreviewUnavailable.scss';

const t = register('GlobalQuestionLabels');

const PreviewUnavailableDialog = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  return (
    <div className="preview-unavailable-overlay">
      <div className="preview-unavailable-dialog">
        <div className="preview-unavailable-header">
          <h3>Feature Unavailable</h3>
        </div>
        <div className="preview-unavailable-body">
          <p>{message || 'This feature is only available during live question answering sessions. It cannot be previewed in this mode.'}</p>
        </div>
        <div className="preview-unavailable-actions">
          <button
            className="btn btn-primary"
            onClick={onClose}
            type="button"
          >
            {t('close')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PreviewUnavailableDialog;
